<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
      >
        <v-flex
          lg12
          sm12
          xs12
        >
          <v-card
            outlined
            class="app-card"
          >
            <v-card-title class="app-card-title">
              Login
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col
                    :md="12"
                    :sm="12"
                    :xs="12"
                    cols="12"
                  >
                    <v-text-field
                      v-model="formattedCnpj"
                      placeholder="Ex.: 12.ABC.345/01DE-35"
                      label="CNPJ *"
                      :rules="[rules.required, rules.cnpj]"
                      maxlength="18"
                      counter="18"
                      hint="Aceita CNPJ numérico ou alfanumérico"
                      persistent-hint
                      filled
                      rounded
                      dense
                    />
                  </v-col>
                  <v-col
                    :md="12"
                    :sm="12"
                    :xs="12"
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.token"
                      placeholder="Digite seu Senha"
                      label="Senha *"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      type="password"
                    />
                  </v-col>
                  <v-col
                    :md="9"
                    :sm="9"
                    :xs="12"
                    cols="12"
                  >
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :load-recaptcha-script="true"
                      class="recaptcha"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                    />
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="3"
                    :xs="12"
                    cols="12"
                  >
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      type="submit"
                    >
                      Continuar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div
                v-if="isLoading"
                class="loading"
              >
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout />
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import AuthService from "@/services/gessan/auth.service";
import {
  formatAlphanumericCNPJ,
  validateAlphanumericCNPJ,
} from "@/helpers/cnpj-alphanumeric.validator";

export default {
  components: {
    VueRecaptcha,
  },
  metaInfo: {
    title: "Saneamento",
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    form: {
      cnpj: "",
      token: "",
      recaptcha: null,
    },
    dataAluno: [],
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      cnpj: (value) => !!validateAlphanumericCNPJ(value) || "CNPJ inválido!",
    },
    openDialog: "",
    alert: false,
    msg: "",
  }),
  computed: {
    formattedCnpj: {
      get() {
        return this.form.cnpj;
      },
      set(value) {
        this.form.cnpj = formatAlphanumericCNPJ(value);
      },
    },
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { cnpj, token } = this.form;
        AuthService.login(cnpj, token)
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}
</style>
